import WhatshotIcon from "@material-ui/icons/Whatshot";
import React, { useState } from "react";
const StockWarningMessage = ({ messageValue, inventoryOnHand, language }) => {
  const message = () => {
    if (messageValue === 0) {
      return language === "english" ? "Few items left!" : "متبقي القليل!";
    } else {
      return language === "english"
        ? `${inventoryOnHand} left`
        : ` متبقي ${inventoryOnHand}`;
    }
  };
  return (
    <>
      <span
        style={{
          color: "red",
          fontSize: 14,
          fontFamily: "Quicksand, Cairo",
          fontWeight: "bold",
        }}
      >
        <WhatshotIcon
          style={{
            fontSize: 14,
            marginBottom: 3,
          }}
        />{" "}
        {message()}
      </span>
      {" - "}
    </>
  );
};

export default StockWarningMessage;
